import { Button, Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/components/DynamicText";
import { DynamicHtml } from "@/components/DynamicHtml";
import { getExpertise } from "@/getters/getExpertise";
import { ExpertiseCard } from "@/components/ExpertiseCard";
import image from "./image.png";
import { getRoute } from "@/routes";
import EditableImage from "@/functions/editableImage";

export default function Requirement({ className, url_slug, expertise: matcher }) {
  const expertise = getExpertise({ matcher });
  const showSpecificExpertise = expertise && !Array.isArray(expertise);

  return (
    <div
      className={clsx(className, classes.requirement)}
      style={{
        backgroundImage: `url(${image}), linear-gradient(0deg, rgba(0, 174, 239, 0) 0%, rgba(0, 174, 239, 0.1) 100%)`,
      }}
    >
      <Container fluid="lg" className="py-5 py-md-6">
        <Row>
          <Col xs={12} md={6}>
            <div className={classes.requirement__expertise}>
              <figure className="mt-md-6 me-lg-5  mb-md-0">
                {showSpecificExpertise ? (
                  <img className="w-100" src={expertise.image} alt={expertise.title} />
                ) : (
                  <EditableImage
                    className="w-100"
                    path={`page.case.study.${url_slug}.requirement.fallback_image`}
                    src={image}
                    alt="A descriptive placeholder for the requirement"
                  />
                )}
              </figure>
              {showSpecificExpertise ? (
                <ExpertiseCard className={classes.requirement__expertise__card} {...expertise} />
              ) : (
                <ExpertiseCard className={classes.requirement__expertise__card}>
                  <DynamicText path={`page.case.study.${url_slug}.card.title`}></DynamicText>
                </ExpertiseCard>
              )}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="ms-md-4 mt-6 mt-md-0">
              <DynamicText
                path={`page.case.study.${url_slug}.requirement.title`}
                tag="h2"
                className="text-blue-dark mb-5"
              >
                The Requirement
              </DynamicText>
              <DynamicHtml path={`page.case.study.${url_slug}.requirement.text`} className="mb-5">
                <p>
                  With the Trust’s internal BAU training team stretched to its limits and end-user system support top of
                  its priority list, extra training resource was required. Searching for PAS experts, the Trust turned
                  to IT Works Health to hire specialist go-live training and floorwalking support.
                </p>
                <p>
                  Moving from multiple PAS systems to a single solution EPR, the implementation was well underway.
                  Spread across 3 sites and over 7000 staff employed – demand for system end-user training at the
                  Northwest Anglia NHS Foundation Trust was at an all-time high.
                </p>
                <p>
                  As a specialist IT recruitment agency, we supported the Trust throughout the hiring process -
                  connecting them to the right experts, at the right time.
                </p>
                <p>
                  <strong>Main Objectives</strong>
                </p>
                <ul>
                  <li>Increased interoperability</li>
                  <li>Improved accessibility of information</li>
                  <li>Quicker information sharing</li>
                  <li>Streamlined information exchange</li>
                  <li>More effective cross-site collaboration</li>
                </ul>
              </DynamicHtml>
              {/* <Button variant="blue" href={getRoute("hiring")}>
                <DynamicText path={`page.case.study.requirement.button.label`}>Employers</DynamicText>
              </Button> */}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
